import {
  _convertPropertyValuesToArray,
  AbstractEntity,
  logComputeFunction,
  ParamsByNames,
  PlethoraLib,
  PropertyValuesDictionary,
  Transaction,
  UiData,
} from "plethora-lib"
import { AbstractUiEntity } from "../UiClasses/AbstractUiEntity"
import { DataTypeShapeType, DataTypeDirection, DataTypeSize, DataTypeColor } from "./GeneratedDataTypes"

export interface ISimulationConfigPropertiesValues {
  Background: string
  Hunter: string
}

export abstract class GeneratedSimulationConfig extends AbstractUiEntity {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super("SimulationConfig", id, propertyValues, [], uiData)
  }

  public computeFunction(propertyName: string, functionParameters: ParamsByNames, uiData: UiData): number {
    let result: number
    switch (propertyName) {
      default:
        throw new Error("Error on computeFunction(), unknown computed property name " + propertyName)
    }
    if (typeof result !== "number") {
      throw new Error("Error on computeFunction(), result is not a number")
    }
    logComputeFunction(this.id, this.name, propertyName, functionParameters, uiData, result)
    return result
  }

  protected onPropertyUpdate(propertyName: string, newValue: any, oldValue: any, uiData: UiData): void {
    super.onPropertyUpdate(propertyName, newValue, oldValue, uiData)
    switch (propertyName) {
      case "Background": {
        this.onBackgroundUpdate(newValue, oldValue, uiData)
        return
      }

      case "Hunter": {
        this.onHunterUpdate(newValue, oldValue, uiData)
        return
      }

      default:
        throw new Error("Unkown property " + propertyName)
    }
  }

  public getBackground(): string {
    return this.getPropertyValue("Background") as string
  }

  public setBackground(value: string, uiData: UiData = null): void {
    this.setPropertyValue("Background", value, uiData, true, null)
  }
  public transactionSetBackground(transaction: Transaction, value: string, uiData: UiData = null): void {
    this.setPropertyValue("Background", value, uiData, true, transaction)
  }

  protected abstract onBackgroundUpdate(newValue: string, oldValue: string, uiData: UiData): void

  public getHunter(): string {
    return this.getPropertyValue("Hunter") as string
  }

  public setHunter(value: string, uiData: UiData = null): void {
    this.setPropertyValue("Hunter", value, uiData, true, null)
  }
  public transactionSetHunter(transaction: Transaction, value: string, uiData: UiData = null): void {
    this.setPropertyValue("Hunter", value, uiData, true, transaction)
  }

  protected abstract onHunterUpdate(newValue: string, oldValue: string, uiData: UiData): void

  protected onAction(actionName: string, actionParameters: ParamsByNames, uiData: UiData): void {
    super.onAction(actionName, actionParameters, uiData)
    switch (actionName) {
      default:
        throw new Error("Unkown action " + actionName)
    }
  }

  protected onInteraction(
    interactionName: string,
    reactorEntity: AbstractEntity,
    interactionParameters: ParamsByNames,
    uiData: UiData
  ): void {
    super.onInteraction(interactionName, reactorEntity, interactionParameters, uiData)
    switch (interactionName) {
      default:
        throw new Error("Unkown interaction " + interactionName)
    }
  }

  public static createRequest(
    propertyValues: Partial<ISimulationConfigPropertiesValues>,
    quantity: number,
    uiData: UiData = null
  ): void {
    PlethoraLib.getInstance()
      .getMessagesManager()
      .sendCreateRequestMessage(
        {
          entityName: "SimulationConfig",
          properties: _convertPropertyValuesToArray(propertyValues),
          quantity,
        },
        uiData
      )
  }
}
